import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e706c3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-upload" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 上传单据")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "container-box" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "报案信息", -1))
const _hoisted_7 = { class: "block-content row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-video-play" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 员工出险视频 ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "案件进展", -1))
const _hoisted_17 = { class: "block-content" }
const _hoisted_18 = { class: "desc" }
const _hoisted_19 = { class: "bill-drawer" }
const _hoisted_20 = { class: "header" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "remark" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-plus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_page_head = _resolveComponent("page-head")!
  const _component_no_data = _resolveComponent("no-data")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, { title: "查看详情" }, {
      right: _withCtx(() => [
        (_ctx.canBill)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.editBill
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2,
                (_ctx.previewList.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.previewList.length) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, "出险人姓名： " + _toDisplayString(_ctx.data.employee?.name), 1),
            _createElementVNode("div", null, "出险人身份证号： " + _toDisplayString(_ctx.data.employee?.idcard), 1),
            _createElementVNode("div", null, "出险人手机号： " + _toDisplayString(_ctx.data.employee_phone), 1),
            _createElementVNode("div", null, "出险时间： " + _toDisplayString(_ctx.data.case_date), 1),
            _createElementVNode("div", null, "出险地址： " + _toDisplayString(_ctx.data.address), 1),
            _createElementVNode("div", null, "是否骨折： " + _toDisplayString(_ctx.data.is_serious ? '是' : '否'), 1),
            _createElementVNode("div", null, "是否住院： " + _toDisplayString(_ctx.data.is_hospital ? '是' : '否'), 1),
            _createElementVNode("div", null, "就诊医院： " + _toDisplayString(_ctx.data.hospital), 1),
            _createElementVNode("div", null, "事故经过： " + _toDisplayString(_ctx.data.desc), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, "报案人手机号： " + _toDisplayString(_ctx.data.reporter_phone), 1),
            _createElementVNode("div", null, "报案时间： " + _toDisplayString(_ctx.data.create_time), 1),
            _createElementVNode("div", null, [
              _createTextVNode(" 投保工种： " + _toDisplayString(_ctx.data.policyPerson?.occupation_name) + " ", 1),
              (_ctx.data.policyPerson?.occupation_level)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(`（${_ctx.data.policyPerson?.occupation_level}类）`), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, "投保日期： " + _toDisplayString(_ctx.data.policyPerson?.start_date), 1),
            _createElementVNode("div", null, " 投保方案： " + _toDisplayString(_ctx.data.policyPerson?.policy?.plan?.name), 1),
            _createElementVNode("div", null, " 被派遣单位： " + _toDisplayString(_ctx.data.policyPerson?.company_name), 1)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.file, (file, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            href: file.url,
            target: "_blank",
            class: "link"
          }, _hoisted_14, 8, _hoisted_11))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (!_ctx.data.trace.length)
            ? (_openBlock(), _createBlock(_component_no_data, {
                key: 0,
                text: "暂无更新记录"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_timeline, { reverse: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.trace, (activity, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  key: index,
                  timestamp: activity.content
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(activity.title) + " ", 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(activity.trace_date), 1)
                  ]),
                  _: 2
                }, 1032, ["timestamp"]))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_drawer, {
        modelValue: _ctx.showBillEdit,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showBillEdit) = $event)),
        title: "上传的单据",
        direction: "rtl"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.bill_formatted, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bill-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(item.type) + "（" + _toDisplayString(item.files.length) + "/" + _toDisplayString(item.max_num) + "） ", 1),
                  (item.is_required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "*"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(item.remark), 1)
                ]),
                _createVNode(_component_el_upload, {
                  name: "iFile",
                  headers: { 'Access-Token': _ctx.token },
                  "show-file-list": true,
                  "file-list": item.files,
                  "list-type": "picture-card",
                  action: "",
                  multiple: "",
                  "http-request": (file) => _ctx.uploadItem(file, item.type),
                  "before-remove": _ctx.delItem,
                  "on-preview": _ctx.handlePreview
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["headers", "file-list", "http-request", "before-remove", "on-preview"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.showPreview)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          style: {"z-index":"9999"},
          "url-list": _ctx.previewList,
          "initial-index": _ctx.previewIndex,
          infinite: "",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPreview = false)),
          "hide-on-click-modal": ""
        }, null, 8, ["url-list", "initial-index"]))
      : _createCommentVNode("", true)
  ], 64))
}